import "./SaifiModalContent.css";
import React, { useEffect, useMemo, useState } from "react";
import { fetchSaifiDetails } from "./api";

const SaifiModalContent = ({ clickInfo, selectedFeature }) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const flatSelectedFeatures = useMemo(() => {
        if (!Array.isArray(selectedFeature)) return [];
        return selectedFeature.flat().filter(Boolean);
    }, [selectedFeature]);

    const clickedLayerId = clickInfo?.layer?.id || "";
    const clickedObject = clickInfo?.object || null;

    const primaryFeature = useMemo(() => {
        if (clickedObject?.id) return clickedObject;

        return (
            flatSelectedFeatures.find((f) => f?.id?.includes("vod")) ||
            flatSelectedFeatures.find((f) => f?.id?.includes("dionica")) ||
            flatSelectedFeatures.find((f) => f?.id?.includes("trafo_stanice")) ||
            null
        );
    }, [clickedObject, flatSelectedFeatures]);

    const getFeatureType = () => {
        const id = primaryFeature?.id || "";
        if (clickedLayerId.includes("vod") || id.includes("vod")) return "vod";
        if (clickedLayerId.includes("dionica") || id.includes("dionica")) return "dionica";
        if (clickedLayerId.includes("trafo_stanice") || id.includes("trafo_stanice")) return "trafo_stanice";
        return null;
    };

    const featureType = getFeatureType();
    const featureId = primaryFeature?.id?.split(".")[1] || null;
    const pripadnostVodu = primaryFeature?.properties?.pripadnost_vodu || null;

    useEffect(() => {
        const load = async () => {
            setData(null);

            if (!featureType || !featureId) return;

            try {
                setIsLoading(true);

                const response = await fetchSaifiDetails({
                    featureType,
                    featureId,
                    pripadnostVodu,
                });

                setData(response);
            } catch (error) {
                console.error("Greška pri učitavanju SAIFI podataka:", error);
                setData({ error: true });
            } finally {
                setIsLoading(false);
            }
        };

        load();
    }, [featureType, featureId, pripadnostVodu]);

    if (isLoading) {
        return (
            <div className="saifi-modal-content">
                <div className="saifi-modal-content__loader-wrap">
                    <div className="saifi-modal-content__loader"></div>
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="saifi-modal-content">
                <div className="saifi-modal-content__empty">
                    Nije izabran nijedan vod.
                </div>
            </div>
        );
    }

    if (data.error) {
        return (
            <div className="saifi-modal-content">
                <div className="saifi-modal-content__error">
                    Greška prilikom učitavanja SAIFI podataka.
                </div>
            </div>
        );
    }
    console.log("DATA",data)

    return (
        <div className="saifi-modal-content">
            <div className="saifi-modal-content__inner">
                <div className="saifi-modal-content__header">
                    <h4 className="saifi-modal-content__title">
                        {data.type === "trafo_stanice" ? "SAIFI - TRAFOSTANICA" : "SAIFI - VOD"}
                    </h4>
                </div>

                <div className="saifi-modal-content__grid">
                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Naziv voda</span>
                        <strong className="saifi-modal-content__value">{data.naziv_voda || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">ID trafostanice</span>
                        <strong className="saifi-modal-content__value">{data.id_trafostanice || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Naziv trafostanice</span>
                        <strong className="saifi-modal-content__value">{data.naziv_trafostanice || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">ID dalekovoda</span>
                        <strong className="saifi-modal-content__value">{data.id_dalekovoda || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Broj korisnika</span>
                        <strong className="saifi-modal-content__value">{data.broj_korisnika ?? 0}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Broj ispada</span>
                        <strong className="saifi-modal-content__value">{data.broj_ispada || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Saifi planirani</span>
                        <strong className="saifi-modal-content__value">{data.saifi_planirani || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card">
                        <span className="saifi-modal-content__label">Saifi neplanirani</span>
                        <strong className="saifi-modal-content__value">{data.saifi_neplanirani || "-"}</strong>
                    </div>

                    <div className="saifi-modal-content__card saifi-modal-content__card--accent">
                        <span className="saifi-modal-content__label">Saifi ukupni</span>
                        <strong className="saifi-modal-content__value">{data.saifi_ukupni || "-"}</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SaifiModalContent;